import $ from 'jquery';
import { debounce } from '../functions/functions.js';
import { $window, $wrapper } from '../variables/variables.js';

$( () => {
	// Создать маску для ввода телефона
	( () => {
		const TEL_MASK = '+000000000000000';

		$( '.field__text[type="tel"]' ).attr( 'maxlength', TEL_MASK.length ).on( 'input', function() {
			let val          = this.value,
				selectionEnd = this.selectionEnd;

			if ( -1 !== TEL_MASK.indexOf( '+7' ) && /^8/.test( val ) ) {
				val = val.replace( '8', '7' );
			}
			val = val.split( '' );

			for ( let i = 0; i < TEL_MASK.length; i++ ) {
				if ( ! val[ i ] ) {
					break;
				}

				const IS_MASK_INT = '0' === TEL_MASK[ i ],
					IS_VAL_INT    = /\d/g.test( val[ i ] ) && ( IS_MASK_INT || val[ i ] !== TEL_MASK[ i ] );

				if ( IS_MASK_INT ) {
					if ( ! IS_VAL_INT ) {
						val.splice( i, 1 );
						i--;
					}
				} else {
					if ( IS_VAL_INT ) {
						val.splice( i, 0, TEL_MASK[ i ] );

						if ( i <= selectionEnd && 1 <= ( selectionEnd - i ) ) {
							selectionEnd++;
						}
					} else {
						val[ i ] = TEL_MASK[ i ];
					}
				}
			}

			this.value = val.join( '' ).substring( 0, TEL_MASK.length );
			this.selectionStart = this.selectionEnd = selectionEnd;
		} );
	} )();

	// Ввести только цифры
	$wrapper.on( 'input keydown contextmenu', '.field__number', function( e ) {
		const $el = $( this );

		let val = $el.val().replace( ',', '.' ).replace( /\s/g, '' );

		const MAX               = $el.attr( 'data-max' ),
			IS_CORRECT_LENGTH = ! MAX || val.length <= MAX.length,
			STEP              = $el.attr( 'data-step' ),
			IS_STEP_FLOAT     = STEP ? ( ( +STEP % 1 ) !== 0 ) : false,
			patternNumper     = IS_STEP_FLOAT ? /^$|^[0-9.,+-]+$/ : /^$|^[0-9+-]+$/;

		if ( /Up|Down/g.test( e.key ) && ! /Page/g.test( e.key ) ) {
			e.preventDefault();
			$el.trigger( /Up/g.test( e.key ) ? 'plus' : 'minus' );

			return;
		}

		if ( patternNumper.test( val ) && IS_CORRECT_LENGTH ) {
			let offset = $el[0].oldVal ? $el[0].oldVal.substring( 0, $el[0].oldStart ).replace( /\S/g, '' ).length : 0;

			if ( +val && $el.hasClass( 'field__number_price' ) ) {
				val = ( +val ).toLocaleString().split( ',' )[0];
			}
			if ( $el[0].oldVal ) {
				offset = val.substring( 0, $el[0].oldStart ).replace( /\S/g, '' ).length - offset;
			}

			$el.val( val );
			if ( ( 'input' === e.type ) && ( val === $el[0].oldVal ) ) {
				$el[0].selectionStart = $el[0].selectionEnd = $el[0].oldStart + offset;
			}

			$el[0].oldVal   = val;
			$el[0].oldStart = $el[0].selectionStart;
			$el[0].oldEnd   = $el[0].selectionEnd;
		} else if ( $el[0].hasOwnProperty( 'oldVal' ) ) {
			const START = $el[0].oldStart,
				END     = $el[0].oldEnd,
				LENGTH  = $el[0].oldVal.length;

			val = $el[0].oldVal.substring( 0, START ) + $el[0].oldVal.substring( END, LENGTH );
			$el.val( val );
			$el[0].selectionStart = $el[0].selectionEnd = START;
		}
	} );

	function setPaddingLeftPrice() {
		$( '.field__number_price' ).each( function() {
			const $input    = $( this );
			const $capttion = $input.prev();

			$input.css(
				'padding-left',
				parseFloat( $capttion.css( 'left' ) ) + $capttion.width() + parseFloat( $capttion.css( 'margin-right' ) ),
			);
		} );
	}
	setPaddingLeftPrice();
	$window.on( 'resizeWidth', debounce( setPaddingLeftPrice ) );
} );
